<script>
import { mixins, Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  props: ['options'],
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData (to, from) {
      if (to) {
        this.renderChart(this.chartData, this.options)
      }
    }
  }
}
</script>

<style>
</style>
